// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v32Le{display:flex;align-items:center;justify-content:space-between;width:360px;margin:10 0 0 30}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"days": `v32Le`
};
export default ___CSS_LOADER_EXPORT___;
